import { ActionTypes } from 'redux/utils/Form'

export default ActionTypes('REFERRAL_REQUEST_ACCEPT')